import { mapState, mapActions } from 'vuex';
import Contract from '@/models/contract';
import { capitalizeFirstLetter } from '@/utils/helpers';

export const PURCHASE_DEFAULT_LABEL = 'N/A';

export default {
  data() {
    return {
      capitalizeFirstLetter,
    };
  },
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('trade', ['tradeOptions']),
    contractModel() {
      return new Contract(this.contract);
    },
    typeFirst() {
      return 'buy';
    },
    typeSecond() {
      if (this.contractModel.mode === 'yes') {
        return 'sell';
      } else if (this.contractModel.mode === 'no') {
        return 'sell';
      }
      return 'buy';
    },
    valueFirst() {
      if (this.contractModel.mode === 'no') {
        return 'no';
      }
      return 'yes';
    },
    valueSecond() {
      if (this.contractModel.mode === 'yes') {
        return 'yes';
      } else if (this.contractModel.mode === 'no') {
        return 'no';
      }
      return 'no';
    },
    priceFirst() {
      let price = this.contractModel.buyYesCostAsCents;
      if (this.contractModel.mode === 'no') {
        price = this.contractModel.buyNoCostAsCents;
      }
      if (price === 100) {
        return '$1';
      }
      return price > 0 ? `${price}¢` : PURCHASE_DEFAULT_LABEL;
    },
    priceSecond() {
      let price = this.contractModel.buyNoCostAsCents;
      if (this.contractModel.mode === 'yes') {
        price = this.contractModel.sellYesCostAsCents;
      } else if (this.contractModel.mode === 'no') {
        price = this.contractModel.sellNoCostAsCents;
      }
      if (price === 100) {
        return '$1';
      }
      return price > 0 ? `${price}¢` : PURCHASE_DEFAULT_LABEL;
    },
    priceFirstClassModifier() {
      return {
        'purchase-yes-no-switcher-sushi__button': true,
        'purchase-yes-no-switcher-sushi__button--yes': this.contractModel.mode !== 'no',
        'purchase-yes-no-switcher-sushi__button--no': this.contractModel.mode === 'no',
        'purchase-yes-no-switcher-sushi__button--active': this.isFirstActive,
      };
    },
    priceSecondClassModifier() {
      return {
        'purchase-yes-no-switcher-sushi__button': true,
        'purchase-yes-no-switcher-sushi__button--yes': this.contractModel.mode === 'yes',
        'purchase-yes-no-switcher-sushi__button--no': this.contractModel.mode !== 'yes',
        'purchase-yes-no-switcher-sushi__button--active': !this.isFirstActive,
      };
    },
    isFirstActive() {
      if (this.contractModel.mode !== '') {
        return this.tradeOptions.operationType === 'buy';
      }
      return this.tradeOptions.operationType === 'buy' && this.tradeOptions.operationValue !== 'no';
    },
  },
  methods: {
    ...mapActions('trade', ['setTradeOptions']),
    switchOperation(operationType, operationValue) {
      this.setTradeOptions({
        contractId: this.contract.contractId,
        operationType,
        operationValue,
      });
    },
    priceFirstClicked() {
      if (this.isFirstActive) return;
      this.switchOperation(this.typeFirst, this.valueFirst);
    },
    priceSecondClicked() {
      if (!this.isFirstActive) return;
      this.switchOperation(this.typeSecond, this.valueSecond);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-yes-no-switcher-sushi/purchase-yes-no-switcher-sushi.js